// extracted by mini-css-extract-plugin
export var container = "_9i-0";
export var icon = "_9i-1";
export var text = "_9i-2";